import { render, staticRenderFns } from "./AssignAreaModal.vue?vue&type=template&id=37f98c95&scoped=true"
import script from "./AssignAreaModal.vue?vue&type=script&lang=js"
export * from "./AssignAreaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f98c95",
  null
  
)

export default component.exports